import React, { Component } from 'react';
import { Form, Input, Select } from 'antd';
import { injectIntl, defineMessages  } from 'react-intl';
import { getPeriodDescription } from '../utils/utils';
import {REPORT_PERIOD, RECEIVER_EMAIL} from '../utils/constants'

const messages = defineMessages({
    email: {
        id: 'Email',
      },    
    email_tip: {
      id: 'ValidEmailTip',
    },  
    schedule: {
        id: 'Schedule',
      },   
});

const layout = {
    labelCol: {
        offset: 1,
        span: 8,
    },
    wrapperCol: {       
        offset: 0,
        span: 8,
    },
  };

class  EmailReportScheduleStep extends Component {

    constructor(props) {
        super(props);

        this.report_type = props.callbacks.getReportType();
        var period = this.getSchedule();
        if (period === undefined)
        {
            period = this.props.schedule[0];
            this.setSchedule(period);
        }

        this.period_desc = this.props.intl.formatMessage({id: getPeriodDescription(period)});

        this.schedule = this.props.schedule.map (item => {
            return {key: item, description: this.props.intl.formatMessage({id: getPeriodDescription(item)})};
        });

        this.state = {
            email : 
            {
                value : this.getReceiver(),
                validateStatus : 'success'
            }
        };

        this.validateEmail(this.state.email.value);
    }

    getReceiver()
    {
         return this.props.callbacks.getStoreValue(this.report_type, RECEIVER_EMAIL);
    }

    setReceiver(value)
    {
         return this.props.callbacks.setStoreValue(this.report_type, RECEIVER_EMAIL, value);
    }

    getSchedule()
    {
         return this.props.callbacks.getStoreValue(this.report_type, REPORT_PERIOD);
    }

    setSchedule(value)
    {
         return this.props.callbacks.setStoreValue(this.report_type, REPORT_PERIOD, parseInt(value, 10));
    }

    validateEmail(value)
    {
        var re = /\S+@\S+\.\S+/;
        if (re.test(value)) 
        {
            this.setReceiver(value);
            this.props.onDisableNext(false);
            return {
              email: {validateStatus: 'success'},
            };
        }
       
        this.props.onDisableNext(true);

        return {
            email : {validateStatus: 'error'},
          };     
    }

    onEmailChange(value)
    {         
          this.setState({ ...this.validateEmail(value), value });
    }

    onScheduleChange(e, option)
    {
        this.setSchedule(option.key);
    }

    render() {
            
        return (
            <div style={{align:"center", textAlign: "left"}}>
                <br/>
                <Form {...layout}
                    name="basic"
                    initialValues={{
                        'receiver': this.state.email.value,
                        'schedule': this.period_desc
                    }}                   
                >
                <Form.Item 
                        label={this.props.intl.formatMessage(messages.email)} 
                        name="receiver" 
                        validateStatus={this.state.email.validateStatus}
                        help={this.props.intl.formatMessage(messages.email_tip)}
                >
                    <Input style={{ width: 360 }} onChange={(e) => this.onEmailChange(e.target.value)} />
                </Form.Item>
                <Form.Item 
                      label={this.props.intl.formatMessage(messages.schedule)} 
                        name="schedule" 
                >
                <Select  style={{ width: 360 }} onChange={(e, option) => {this.onScheduleChange(e, option)}}>
                    {this.schedule.map(item => 
                        <Select.Option key  = {item.key} value={item.description}>{item.description}</Select.Option>)
                    }
                </Select>
                </Form.Item>
                </Form>
            </div>
        );
      }
}

export default injectIntl(EmailReportScheduleStep, {
    withRef: true,
  });